import i18next from "i18next"
import { PASSWORD_MAX_LENGTH } from "utils/passwordValidation"
import { NUMERIC_SAFE_MAX } from "utils/numericValidation"

export const getFieldRequiredMessage = () => i18next.t("Field is required")

export const getFieldOnlyLetters = () =>
  i18next.t("Field can only contain letters")

export const getRoleNameMustHaveLetterMessage = () =>
  i18next.t("Role name must include at least one letter")

export const getRoleNameInvalidCharsMessage = () =>
  i18next.t(
    "Role name may only contain letters, numbers, spaces, and - _ ' & ."
  )

export const getNameNoParenthesesMessage = () =>
  i18next.t("Parentheses are not allowed in this field")

export const getRoleNameMinLengthMessage = () =>
  i18next.t("Role name must be at least 2 characters")

export const getRoleNameMaxLengthMessage = max =>
  i18next.t("Role name cannot exceed {{max}} characters", { max })

export const getRoleNameArabicMustHaveLetterMessage = () =>
  i18next.t("Arabic role name must include at least one Arabic letter")

export const getPersonNameMustHaveLetterMessage = () =>
  i18next.t("Name must include at least one letter")

export const getPersonNameInvalidCharsMessage = () =>
  i18next.t("Name may only contain letters, spaces, and - ' .")

export const getPersonNameMinLengthMessage = () =>
  i18next.t("Name must be at least 2 characters")

export const getValidArabicMessage = () =>
  i18next.t("Please enter a valid Arabic name")

export const getEnglishTextOnlyMessage = () =>
  i18next.t("Please enter English text only")

export const getArabicTextOnlyMessage = () =>
  i18next.t("Please enter Arabic text only")

export const getEnglishNameMustHaveLetterMessage = () =>
  i18next.t("Name must include at least one English letter")

export const getArabicNameMustHaveLetterMessage = () =>
  i18next.t("Name must include at least one Arabic letter")

export const getCountryNameEnglishInvalidCharsMessage = () =>
  i18next.t(
    "Country name may only contain English letters, spaces, and hyphens"
  )

export const getCountryNameArabicInvalidCharsMessage = () =>
  i18next.t("Country name may only contain Arabic letters, spaces, and hyphens")

export const getCountryNameHyphenMessage = () =>
  i18next.t(
    "Hyphens are only allowed between words (e.g. Timor-Leste) and cannot appear at the start, end, or consecutively"
  )

export const getQtyInteger = () =>
  i18next.t("Quantity must be a whole number")

export const getWholeNumberMessage = () =>
  i18next.t("value must be a whole number")

export const getNoSpaceMessage = () =>
  i18next.t("This field cannot contain white spaces")

export const getEmailMessage = () => i18next.t("Please Enter Your Email")

export const getValidEmail = () =>
  i18next.t("Please enter a valid email address")

export const getEmailTotalMaxMessage = () =>
  i18next.t("Email address cannot exceed 320 characters")

export const getEmailLocalPartMaxMessage = () =>
  i18next.t("The part before @ cannot exceed 64 characters")

export const getEmailDomainPartMaxMessage = () =>
  i18next.t("The part after @ cannot exceed 255 characters")

export const getValidPhoneMessage = () =>
  i18next.t("Please enter a valid phone number")

export const getMin6PasswordMessage = () =>
  i18next.t("Password must be at least 6 characters")

export const getPasswordStrengthMessage = () =>
  i18next.t(
    "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a special character."
  )

export const getMaxPasswordMessage = () =>
  i18next.t("Password cannot exceed {{max}} characters", {
    max: PASSWORD_MAX_LENGTH,
  })

export const getPasswordMatchMessage = () => i18next.t("Passwords must match")

export const getArabicDescMessage = () =>
  i18next.t("Please enter a valid Arabic description")

export const getRoleDescriptionUnsafeContentMessage = () =>
  i18next.t("Description cannot contain HTML or script content.")

export const getBrandNameMustHaveLetterMessage = () =>
  i18next.t("Brand name must include at least one letter.")

export const getBrandNameInvalidCharsMessage = () =>
  i18next.t(
    "Brand name may only contain letters, numbers, spaces, and - _ ' & ."
  )

export const getBrandUrlInvalidMessage = () =>
  i18next.t("Please enter a valid URL")

export const getInvalidImageUrlMessage = () =>
  i18next.t(
    "Please enter a valid image URL (JPEG, PNG, or WebP). The link must open an image, not a webpage or document."
  )
export const getInvalidLatitudeMessage = () =>
  i18next.t("Latitude must be between -90 and 90")

export const getInvalidLongitudeMessage = () =>
  i18next.t("Longitude must be between -180 and 180")

export const getBrandLocationInvalidCharsMessage = () =>
  i18next.t("This field may only contain letters, spaces, - and '")

export const getBrandPostalCodeInvalidMessage = () =>
  i18next.t("Postal code may only contain letters, numbers, spaces, and -")

export const getDescriptionMaxLengthMessage = max =>
  i18next.t("Description cannot exceed {{max}} characters", { max })

export const getBrandNameMinLengthMessage = () =>
  i18next.t("Brand name must be at least 2 characters.")

export const getBrandNameMaxLengthMessage = max =>
  i18next.t("Brand name cannot exceed {{max}} characters.", { max })

export const getBrandNameNumericOnlyMessage = () =>
  i18next.t("Brand name cannot be numeric-only.")

export const getBrandNameSpecialCharsOnlyMessage = () =>
  i18next.t("Brand name cannot contain only special characters.")

export const getBrandNameUnsafeContentMessage = () =>
  i18next.t("Brand name cannot contain HTML or script content.")

export const getBrandNameInvalidCatalogMessage = () =>
  i18next.t("Please select a valid brand name from the list.")

export const getBrandTextUnsafeContentMessage = () =>
  i18next.t("This field cannot contain HTML or script content.")

export const getBrandAppBrandIdInvalidMessage = () =>
  i18next.t("App Brand ID may only contain letters, numbers, - and _.")

export const getBrandAppBrandIdMaxLengthMessage = max =>
  i18next.t("App Brand ID cannot exceed {{max}} characters.", { max })

export const getArabicLinkMessage = () =>
  i18next.t("Please enter a valid Arabic link label")

export const getDisplayNumMessage = () =>
  i18next.t("Display Order must be a number")

export const getMinimumNegMessage = () =>
  i18next.t("Minimum value cannot be negative")

export const getMinimumCountMessage = () =>
  i18next.t("Minimum value cannot be less than 1")

export const getValidNumMessage = () => i18next.t("Please enter a valid number")

export const getSafeNumberLimitMessage = () =>
  i18next.t("Please enter a valid number within the allowed limit (max {{max}}).", {
    max: NUMERIC_SAFE_MAX,
  })

export const getOnlyNumMessage = () =>
  i18next.t("This field must contain only numbers")

export const getValue0To100 = () => i18next.t("Value must be between 0 and 100")

export const getQtyNum = () => i18next.t("Quantity must be a number")

export const getQtyPositive = () => i18next.t("Quantity must be positive")

export const getMinExact1 = () => i18next.t("Minimum value must be exactly 1")

export const getMaxExact1 = () => i18next.t("Maximum value must be exactly 1")

export const getMaxMustGreaterMin = () =>
  i18next.t("Maximum value must be greater than minimum value")

export const getAlfaNumericChar = () =>
  i18next.t("Only alphanumeric characters are allowed")

export const getMinOneCustomer = () =>
  i18next.t("At least one customer must be selected")

export const getMinOneLocation = () =>
  i18next.t("At least one branch must be selected")

export const getMinOneSetting = () =>
  i18next.t("At least one setting must be selected")

export const getMinOneItemGroup = () =>
  i18next.t("Please select at least one item group")

export const getOnlyNumAndChar = () =>
  i18next.t("Only numbers and characters are allowed (no spaces)")

export const getBulkCouponPrefixMaxLengthMessage = max =>
  i18next.t("Prefix cannot exceed {{max}} characters", { max })

export const getCouponNameMaxLengthMessage = max =>
  i18next.t("Coupon name cannot exceed {{max}} characters", { max })

export const getCouponCodeLengthMessage = () =>
  i18next.t("Coupon code must be between 3 and 10 characters")

export const getInvalidCsvFileMessage = () =>
  i18next.t("Invalid file format. Please upload a valid CSV file.")

export const getValueBt3To10 = () => i18next.t("Value must be between 3 and 10")

export const getValueBt1To1000 = () =>
  i18next.t("Value must be between 1 and 1000")

export const getGreaterOrEqual0 = () =>
  i18next.t("Value must be greater than or equal to 0")

export const getDialCodeStart = () => i18next.t("Dial code must start with +")

export const getDialCodeFormatMessage = () =>
  i18next.t("Dial code must start with + followed by digits only")

export const getCountryCodeFormatMessage = () =>
  i18next.t("Country code must be 2 or 3 letters only")

export const getExpiredDateMsg = () =>
  i18next.t("Expiry date must be later than start date")

export const getInvalidFormat = () => i18next.t("Invalid email format")

export const getNotificationTextEnglishLetterMessage = () =>
  i18next.t("Text must include at least one English letter")

export const getNotificationTextArabicLetterMessage = () =>
  i18next.t("Text must include at least one Arabic letter")

export const getNotificationTextMaxLengthMessage = max =>
  i18next.t("Text cannot exceed {{max}} characters", { max })

export const getNotificationTextUnsafeContentMessage = () =>
  i18next.t("Text cannot contain HTML or script content.")
